import React, { Component, Fragment } from 'react'
import Button from '../../../components/atoms/Button'
import TextBox from '../../../components/atoms/TextBox'
import SelectFiles from '../../../components/atoms/SelectFiles'
import LabelWithInput from '../../../components/molecules/LabelWithInput';
import TextArea from '../../../components/atoms/TextArea'
import Loading from '../../../components/molecules/Loading'
import InformationText from '../../../components/molecules/InformationText'
import { URL_API_FILE_FINANCE_STATEMENT } from '../../../config/api'
import UploadOneImages from '../../../utils/actions/UploadOneImages'
import curencyFormat from '../../../utils/helpers/curencyFormat'

export class DataPinjaman extends Component {
    _isMounted = false;
    constructor(props){
        super(props);
        this.state = {
            pinjamanLain : '',
            tujuan : '',
            mutation_file : {
                error : null,
                loading : false,
                link : ''
            },
            financial_statement_file : {
                error : null,
                loading : false,
                link : ''
            },
            load_back : false,
            load_next : false
        }
    }

    onChangeHandler = ({value, name}) => {
        if(name === 'pinjamanLain'){
            value = value.replace(/\D/g,"")
        }
        console.log({ value, name });

        if (this._isMounted) {
            this.setState({
                [name] : value
            })
        }
    }

    setStateList = (parent, child, value) => {
        if (this._isMounted) {
            this.setState({
                [parent] : {
                    ...this.state[parent],
                    [child] : value
                }
            })
        }
    }

    uploadFile = (name, value) => {
        const { RefreshToken} = this.props;
        const {loanCode} = this.props.match.params;
        this.setStateList(name, 'loading', true);

        // if(ClientID){
            let url = null;
            RefreshToken((ClientID) => {
                if(ClientID){
                    UploadOneImages(URL_API_FILE_FINANCE_STATEMENT(loanCode), {name : name, file : value}, ClientID, (hasil, error) => {
                        this.setStateList(name, 'loading', false);
                        if(!error){
                            url = (name == 'mutation_file') ?  hasil.document.mutation.url : hasil.document.financialStatement.url
                            this.setStateList(name, 'link',  url);
                        }else{
                            this.setStateList(name, 'error', error);
                        }
                    });
                }
            })
        // }
    }
    onSubmitBack = (step) => {
        const {pinjamanLain, tujuan, mutation_file, financial_statement_file} = this.state;
        const {loanCode} = this.props.match.params;
        const {SetError, postOrPatch} = this.props;
        
        if (this._isMounted) {
            this.setState({
                load_back : (step == 0) ? true : false,
                load_next : (step == 2) ? true : false
            })
        }
        let loanDetail = {}
        if(tujuan){
            loanDetail.loanPurpose = tujuan
        }
        if(pinjamanLain){
            loanDetail.otherLoanAmount = `${pinjamanLain}`
        }
        console.log({loanDetail});
        
        postOrPatch({
            data : {loanDetail},
            stepChange : step,
            loanCode
        })
    }
    onSubmitStep = (step) => {
        const {pinjamanLain, tujuan, mutation_file, financial_statement_file} = this.state;
        const {loanCode} = this.props.match.params;
        const {SetError, postOrPatch, submit} = this.props;

        if (this._isMounted) {
            this.setState({
                load_back : (step == 1) ? true : false,
                load_next : (step == 4) ? true : false
            })
        }

        (pinjamanLain == '' || tujuan == '' || mutation_file.link  == '' || financial_statement_file.link == '') ? SetError('Semua field di tahap ini harus diisi sebelum Anda pindah ke tahap selanjutnya.') :
        postOrPatch({
            data : {
                loanDetail: {
                    loanPurpose : tujuan,
                    otherLoanAmount: `${pinjamanLain}`
                }
            },
            stepChange : step,
            loanCode
        })
    }

    componentDidMount = () => {
        this._isMounted = true;
        this.props.ResetStatusState();
        console.log('Mount Data Pinjaman')
    }

    componentDidUpdate = (prevProps) => {
        if(this.props.detailPinjaman.detail !== prevProps.detailPinjaman.detail){
            if(this.props.detailPinjaman.detail !== null){
                const {loanPurpose, otherLoanAmount, infoDocs} =this.props.detailPinjaman.detail;

                if (this._isMounted) {
                    this.setState({
                        pinjamanLain : otherLoanAmount ? (otherLoanAmount > 0 ? Number(otherLoanAmount) : '' ) : '' ,
                        tujuan : loanPurpose ? loanPurpose : '',
                        mutation_file : {
                            ...this.state.invois,
                            link : (infoDocs.mutation) ? infoDocs.mutation.url : ''
                        },
                        financial_statement_file : {
                            ...this.state.invois,
                            link : (infoDocs.financialStatement) ? infoDocs.financialStatement.url : ''
                        },
                    })
                }
            }
        }
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    render() {
        const {detailPinjaman, col, status} = this.props;
        const {pinjamanLain, tujuan, mutation_file, financial_statement_file, load_back, load_next} = this.state;

        return (
            detailPinjaman.loading ? <Loading /> :(
                <Fragment>
                    <LabelWithInput label='Total nilai pinjaman selain di KlikCair?' col={col} {...this.props} >
                        <TextBox onChange={e => {this.onChangeHandler(e.target)}} value={pinjamanLain ? curencyFormat(pinjamanLain) : ''}  name='pinjamanLain' /> 
                    </LabelWithInput>

                    <LabelWithInput label='Tujuan Pinjaman' col={col} {...this.props}>
                        <TextArea onChange={e => {this.onChangeHandler(e.target)}} value={tujuan} name='tujuan' rows='4' />
                    </LabelWithInput>

                    <LabelWithInput label='Unggah Mutasi Rekening per Semester Terakhir' col={col} {...this.props} info='File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB' note={mutation_file.error}>
                        <SelectFiles name='mutation_file' extention='.pdf,.png,.jpg,.jpeg' onChange={(name, value) => {this.uploadFile(name, value)}}  loading={mutation_file.loading} files={mutation_file.link} />
                    </LabelWithInput>

                    <LabelWithInput label='Unggah Laporan Keuangan per Semester Terakhir' col={col} {...this.props} info='File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB' note={financial_statement_file.error}>
                        <SelectFiles name='financial_statement_file' extention='.pdf,.png,.jpg,.jpeg' onChange={(name, value) => {this.uploadFile(name, value)}}  loading={financial_statement_file.loading} files={financial_statement_file.link} />
                    </LabelWithInput>

                    <div className='bg-button'>
                        <Button title='Kembali' color='outline' width='big' loading={status.loading && load_back} onClick={() => this.onSubmitBack(1)} />
                        <Button title='Kirim' color='blue' width='big' loading={status.loading && load_next} onClick={() => this.onSubmitStep(4)} />
                    </div>

                    {/* { ( status.error ) && <InformationText value={status.error} type='error' className='mt-3' /> } */}
                </Fragment>
            )
        )
    }
}

export default DataPinjaman;
